export interface PackagingDimensions {
  length?: number;
  width?: number;
  height?: number;
}

export interface PackagingDimensionFormState {
  foldedLength: string;
  foldedWidth: string;
  foldedHeight: string;
  assembledLength: string;
  assembledWidth: string;
  assembledHeight: string;
  dimensionUnit: string;
}

export const EMPTY_DIMENSION_FORM: PackagingDimensionFormState = {
  foldedLength: '',
  foldedWidth: '',
  foldedHeight: '',
  assembledLength: '',
  assembledWidth: '',
  assembledHeight: '',
  dimensionUnit: 'cm',
};
